import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchClientConfig } from '../api/config';

const configFetchAtom = atom(async () => {
    const data = await fetchClientConfig();
    return data;
});

const configLoadableAtom = loadable(configFetchAtom);
const configOverrideAtom = atom(null);

export const configAtom = atom(
    (get) => {
        const override = get(configOverrideAtom);
        if (override !== null) return override;
        const fetched = get(configLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : null;
    },
    (get, set, update) => {
        const override = get(configOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(configLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data : null;
        }
        set(configOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);
